import React from 'react';
import { connect } from 'react-redux';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { ChairInfo, Info, TableFriendlyName } from '../../store/info/types';
import { AppState } from '../../store/state';
import { AppDispatch } from '../../store/store';
import { selectInfo, selectKeywordState, selectTrackRoles } from '../../store/selectors';
import { Role } from '../../store/conference/types';
import Loading from '../../components/Loading/Loading';
import { formatKeywordColumn } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import { getRoleName } from '../../helpers/translations';
import useFetchTableData from '../../store/table/useFetchTableData';
import { stringifyOrganization } from '../../helpers/users';

interface Props {
  info: Info;
  loading: boolean;
  roleById: { [key: number]: Role };
  keywordById: { [key: number]: Keyword };
}

const PeopleChairPage: React.FC<Props> = ({ loading, info, roleById, keywordById }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'users';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  const chairInfo = info as ChairInfo;

  const { byId } = chairInfo.users;
  /* Initialize fields */
  const inputData: unknown[] = [];
  Object.values(byId).forEach((register, index) => {
    if (register.role_ids.length) {
      const newRegister = { ...register };
      const roleNames = newRegister.role_ids.map((id) => getRoleName(roleById[id], t));
      if (newRegister.is_conference_admin) {
        roleNames.push(t('Conference owner'));
      }
      newRegister.roles = roleNames.join(';');

      formatKeywordColumn(newRegister, keywordById);

      newRegister.organization = stringifyOrganization(newRegister);

      inputData.push(newRegister);
    }
  });

  return (
    <div className="flex flex-col h-full">
      <div className="mb-2 h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  info: state.info.info,
  loading: selectInfo(state).loading,
  roleById: selectTrackRoles(state),
  keywordById: selectKeywordState(state).keywordById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleChairPage);
